import type { TDateTime } from "@/utils/time";

import { isDefined } from "@voltalis/frontend-utils";

import $date from "@/utils/date";

export function isProgrammingRangeStartDateAllowed(startDate: Date, now: Date, initialStart?: TDateTime): boolean {
  const startMilliseconds = $date.getDateMilliseconds(startDate);
  if (startMilliseconds >= $date.getDateMilliseconds(now)) return true;

  return isDefined(initialStart) && startMilliseconds === $date.getDateMilliseconds(initialStart);
}
